
import { mapMutations } from 'vuex';
import get from 'lodash/get';

export default {
  name: 'SearchForm',
  data() {
    return {
      form: {
        startingPoint: '',
        parkingProvider: '',
        parkingService: '',
      },
    };
  },
  computed: {
    merchantsOptions() {
      return this.$store.state.merchants
        .filter((merchant) => Array.isArray(merchant.types) && merchant.types.length)
        .map((merchant) => ({
          value: merchant.id,
          title: merchant.name,
        }))
        .sort((a, b) => a.title.localeCompare(b.title));
    },
    parkingServicesOptions() {
      if (this.form.parkingProvider) {
        return (
          this.$store.state.merchants
            ?.find((merchant) => merchant.id === this.form.parkingProvider)
            .types.map((type) => ({
              title: this.$i18n(`reservation.${type.price_type}`),
              value: type.price_type,
            })) ?? []
        );
      }
      return [];
    },
    parkingProvider() {
      return this.$store.state.merchants?.find((merchant) => merchant.id === this.form.parkingProvider) ?? null;
    },
    airport() {
      return this.$store.state.airport;
    },
    language() {
      return this.$store.state.language;
    },
  },
  watch: {
    parkingProvider: {
      handler(value) {
        this.form.parkingService = '';
        this.setParkingProvider(value);
      },
    },
    'form.parkingService': {
      handler(value) {
        const parkingService = this.parkingProvider?.types.find((type) => type.price_type === value) ?? null;
        this.setParkingService(parkingService);
        this.$store.dispatch('route/getMerchantContent', {
          merchantId: this.form.parkingProvider,
          locationId: this.airport.id,
          languageId: this.language.id,
          parkType: this.form.parkingService,
        });
      },
    },
  },
  mounted() {
    this.$nuxt.$on('map-custom-search', this.customSearch);
    this.fetchParkingDetails();
  },
  destroyed() {
    this.$nuxt.$off('map-custom-search', this.customSearch);
  },
  methods: {
    ...mapMutations({
      setParkingProvider: 'route/setParkingProvider',
      setParkingService: 'route/setParkingService',
    }),
    customSearch({ search }) {
      if (search) {
        this.form.startingPoint = search;
        this.search();
      }
    },
    search() {
      this.$emit('search', this.form.startingPoint);
    },
    async fetchParkingDetails() {
      const { iorderid, email } = this.$route.query;

      if (!iorderid || iorderid === 'undefined' || !email || email === 'undefined') {
        return;
      }

      const data = await this.$pbx.getParkingDetails(iorderid, email, Number(this.language.id));

      const merchantId = get(data, 'merchantId');
      const merchantOptionExist = this.merchantsOptions.some((option) => option.value === merchantId.toString());

      if (!merchantOptionExist) {
        return;
      }

      const parkingType = get(data, 'parkingType');
      this.form.parkingProvider = merchantId.toString();

      this.$nextTick(() => {
        this.form.parkingService = parkingType;
      });
    },
  },
};
